import type { BadgeSurface, BadgeVisibilityOverrides, LockBadge, LockBadgeKind } from '../types/gamificationBadges';
import type { GroupedGamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';
import { BADGE_VISIBILITY_OVERRIDES, DEFAULT_BADGE_VISIBILITY } from '../constants/statusRewardBadgeVisibility';

interface Params {
  statusName?: string;
  type: GroupedGamificationRewardType;
  kind: LockBadgeKind | null;
}

export const getBenefitLockBadges = (
  { type, kind, statusName }: Params,
  overrides: BadgeVisibilityOverrides = BADGE_VISIBILITY_OVERRIDES,
): Record<BadgeSurface, LockBadge> => {
  const getBadge = (surface: BadgeSurface): LockBadge => {
    if (!kind || (kind === 'needs-status' && !statusName)) {
      return null;
    }

    const isVisible = overrides[type]?.[surface]?.[kind] ?? DEFAULT_BADGE_VISIBILITY[surface][kind];
    if (!isVisible) {
      return null;
    }

    if (kind === 'coming-soon') {
      return { kind: 'coming-soon' };
    }

    return { kind: 'needs-status', statusName: statusName as string };
  };

  return { statuses: getBadge('statuses'), rewardsGrid: getBadge('rewardsGrid') };
};
